/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>PostHog service error messages and magic strings</blockquote>
 *
 * @example
 * ```typescript
 * import { POSTHOG_MESSAGES } from '@shared/reporting';
 *
 * console.error(POSTHOG_MESSAGES.CLIENT_NOT_INITIALIZED); // 'PostHog client not initialized'
 * ```
 */
export const POSTHOG_MESSAGES = {
  CLIENT_NOT_INITIALIZED: 'PostHog client not initialized',
  REPORTING_FAILED: 'PostHog reporting failed',
  FAILED_TO_REPORT_EVENT: 'Failed to report event to PostHog',

  // Initialization messages
  INITIALIZING_SERVER: '🖥️  Initializing PostHog for Node.js environment...',
  SERVER_INIT_SUCCESS: '✅ PostHog Node.js client initialized successfully',
  SERVER_READY: '📊 Ready to capture events in server environment',
  INSTANCE_READY: '🎯 PostHog instance ready for use',
  INIT_FAILED: '❌ Failed to initialize PostHog: {error}',
  API_KEY_REQUIRED: '❌ PostHog API key is required',

  // Event capture messages
  CAPTURING_SERVER_EVENT: '📤 Capturing PostHog server event: {event}',
  DISTINCT_ID_INFO: '👤 Distinct ID: {id}',
  EVENT_ID_INFO: '🆔 Event ID: {id}',
  SERVER_EVENT_SUCCESS: '✅ PostHog Server event captured successfully',
} as const;
